import React from 'react'
import PropTypes from 'prop-types';
import find from 'lodash/find';

import { Fade } from '../componentAnimations'

import AddressSelectorList from "./AddressSelectorList"
import AddressDisplay from "./AddressDisplay"
import AddressEditorContainer from "./AddressEditorContainer"
import CheckoutSection from "./CheckoutSection"

import { Address, AddressActionCreators } from '../models'
import { hiddenAnchorStyle } from './styles'

class CheckoutAddressComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listCollapsed: props.selectedAddressId ? true : false,
      editId: ''
    };
    this.onClickCollapse = this.onClickCollapse.bind(this);
    this.onDoneSelecting = this.onDoneSelecting.bind(this);
    this.onBeginEdit = this.onBeginEdit.bind(this);
    this.onEndEdit = this.onEndEdit.bind(this);
    this.onEditCancel = this.onEditCancel.bind(this);
  }

  onClickCollapse(e) {
    e.preventDefault();
    this.setState({ listCollapsed: !this.state.listCollapsed });
  }

  onDoneSelecting() {
    this.setState({ listCollapsed: true });
  }

  onBeginEdit(Id) {
    this.setState({ editOpen: true, editId: Id, listCollapsed: true });
  }
  
  onEndEdit(Id) {
    this.setState({ editOpen: false });
    this.props.onEndEdit(Id);
  }

  onEditCancel() {
    this.setState({ editOpen: false, listCollapsed: false })
  }
  
  render() {
    const selectedAddress = find(this.props.addresses,
      address => address.Id === this.props.selectedAddressId);
    return (
      <Fade inProp={!this.props.hidden}>
        <CheckoutSection label={this.props.sectionLabel} hidden={this.props.hidden}>

          <div >
                    <div className='mb-3'>
              <a 
                href=""
                onClick={(e) => this.onClickCollapse(e)}
                style={hiddenAnchorStyle}
              >
                <AddressDisplay
                  address={selectedAddress}
                  compact={true}
                />
              </a>
            </div>
          </div>
          {this.props.onUseForAnotherClicked &&
              <div className='mb-3'>
                  <span
                    style={{ marginLeft: 10 }}
                    onClick={this.props.onUseForAnotherClicked}>
                    <input
                      type="checkbox"
                      checked={this.props.useForAnotherSelected}
                      id='useForAnother'
                      readOnly={true} />
                    <label
                      htmlFor='#useForAnother'>
                      {this.props.useForAnotherMessage}
                    </label>
                  </span>
              </div>
          }
          
          { this.state.editOpen
            ? (
              <React.Fragment>
                <AddressEditorContainer
                  addressId={this.state.editId}
                  addressActionCreators={this.props.addressActionCreators}
                  addressType={this.props.addressType}
                  onAddressCreated={this.onEndEdit}
                  onAddressUpdated={this.onEndEdit}
                  onEditCancel={this.onEditCancel}
                />
              </React.Fragment>
            )
            : (
              <React.Fragment>
                
                  <div className=''>
                      <a
                        href=""
                        style={{ textDecoration: 'none', fontWeight: '600' }}
                        onClick={(e) => this.onClickCollapse(e)}>
                        {this.state.listCollapsed ? "Add/Edit Addresses" : "Done"}
                      </a>
                    </div>
                <Fade inProp={!this.state.listCollapsed}>
                  <AddressSelectorList
                    onBeginEdit={this.onBeginEdit}
                    addresses={this.props.addresses}
                    selectedAddressId={this.props.selectedAddressId}
                    onDoneSelecting={this.onDoneSelecting}
                    selectAddressMessage={this.props.selectAddressMessage}
                    addressActionCreators={this.props.addressActionCreators}
                  />
                </Fade>
              </React.Fragment>
            )}
        </CheckoutSection>
      </Fade>
    );
  }
}

CheckoutAddressComponent.propTypes = {
  addresses: PropTypes.arrayOf(Address.propTypes).isRequired,
  selectedAddressId: PropTypes.string,
  addressType: PropTypes.number.isRequired,
  addressActionCreators: AddressActionCreators.propTypes,
  selectAddressMessage: PropTypes.string.isRequired,
  sectionLabel: PropTypes.string.isRequired,
  onEndEdit: PropTypes.func.isRequired
}

export default CheckoutAddressComponent;